module.exports = __webpack_public_path__ + "static/projectsbg-1905d3553f10a75c3506825c471c31f1.jpg";